// extracted by mini-css-extract-plugin
export default {"button-list":"styles_button-list__2FboK","child":"styles_child__OOt0G"};